import Axios from 'axios';

export interface Manual {
  name: string;
  url: string;
  size: number;
  updateDate: Date;
  localUrl: string | null;
}

interface State {
  loading: boolean;
  manualList: Manual[];
}
const mapState: State = {
  loading: false,
  manualList: new Array<Manual>(),
};

const mapActions = {
  async fetchManualList({ commit }: any) {
    commit('setLoading', true);
    const response = await Axios.post('/api/Manual/ListView').catch((error) => {
      commit('setLoading', false);
      throw error;
    });
    response.data.manualList.forEach((manual: any) => {
      if (typeof manual.updateDate === 'string') {
        manual.updateDate = new Date(manual.updateDate);
      }
      manual.localUrl = null;
    });
    commit('fetchManualList', response.data);
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  fetchManualList(state: State, data: any) {
    state.manualList = data.manualList;
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
